var _path, _path2, _polygon, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEcommerceI(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-6",
    d: "M74.82,242.57c-96.75,55.86-96.74,146.42,0,202.28s253.6,55.86,350.35,0,96.74-146.42,0-202.28S171.57,186.72,74.82,242.57Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--Shadow--inject-6",
    points: "21.88 339.56 75.48 308.62 129.08 339.56 75.48 370.51 21.88 339.56",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-6",
    d: "M323.1,344.5,168.44,433.75c-1.81,1-1.81,2.74,0,3.78l24.2,13.94a7.27,7.27,0,0,0,6.55,0l154.67-89.24c1.81-1.05,1.81-2.74,0-3.79L329.65,344.5A7.27,7.27,0,0,0,323.1,344.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-6",
    points: "89.53 394.51 143.13 363.56 196.73 394.51 143.13 425.46 89.53 394.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-6",
    points: "332.93 235.3 392.54 200.88 452.16 235.3 392.54 269.72 332.93 235.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-6",
    points: "362.16 300.9 421.78 266.48 481.4 300.9 421.78 335.32 362.16 300.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-6",
    d: "M259.09,481.13,226.5,462.32c-2.43-1.41-2.43-3.69,0-5.1l122.09-70.49a9.74,9.74,0,0,1,8.83,0L390,405.54c2.44,1.41,2.43,3.69,0,5.1L335,442.4l-67.08,38.73A9.79,9.79,0,0,1,259.09,481.13Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gifts--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gift--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gift--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "75.48 365.26 28.15 337.9 28.15 279.67 27.15 279.09 27.15 265.14 75.48 293.04 75.48 365.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.48 307 57.36 296.54 28.15 279.67 28.15 281.68 75.48 309 75.48 307",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.48 365.26 122.55 338.1 122.55 279.82 123.81 279.09 123.81 265.14 75.48 293.04 75.48 365.26",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.56 279.82 75.48 307 75.48 309 122.56 281.85 122.56 279.82",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.81 265.14 75.48 237.24 27.15 265.14 75.48 293.04 123.81 265.14",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.11 353.94 95.11 281.71 102.96 277.18 102.96 349.4 95.11 353.94",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.85 353.94 55.85 281.71 48 277.18 48 349.4 55.85 353.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.85 353.94 55.85 281.71 48 277.18 48 349.4 55.85 353.94",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.96 277.18 54.63 249.28 46.78 253.81 95.11 281.71 102.96 277.18",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.12 270.75 83.97 266.22 76.12 261.69 68.27 266.22 76.12 270.75",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.85 281.71 104.18 253.81 96.33 249.28 48 277.18 55.85 281.71",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.6,253.5c.76,3.29,5.56,12.85,20.8,13.89L77,266s-17.7-4.43-13.86-19.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.13,269.2s0-9.38-3.56-14.91-10.48-8.2-10.48-8.2a21.91,21.91,0,0,0-8.49,7.41,28.77,28.77,0,0,1,12.25,3.11c6,3.17,8.55,10.78,8.55,10.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7,256.54l6.17-3.25a19.87,19.87,0,0,0-3.49-3.49l-8.14,4.66A26.56,26.56,0,0,1,66.7,256.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.46,270.73s10.43,2.74,23.67-1.53l-1-1.81s-6.89,1.16-11.77,0-9-8.09-9-8.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.13,269.2s-.12-2.57-3.74-5.94c-4.75-4.41-14-4.41-18.07-4a8.24,8.24,0,0,0-3.12,5.13c-.49,2.51,1.26,6.3,1.26,6.3a15.19,15.19,0,0,1,10.84-5.44,14.87,14.87,0,0,1,10.62,3.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.08,259.35a38,38,0,0,0-4.63-.22,8.86,8.86,0,0,0-2.13,9,15.74,15.74,0,0,1,4.83-2.26A10.42,10.42,0,0,1,63.08,259.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.46,282.87s5.63-.68,9.18-4.76a19.84,19.84,0,0,0,4.49-8.91l-1.73-1.81a13.66,13.66,0,0,1-6.73,7c-4,1.77-11.46,1.75-11.46,1.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.13,269.2l-1.73-1.81s-6.69-1.35-10.3,0-7.81,7-7.89,8.72a10.57,10.57,0,0,0,6.25,6.76s-.34-6.16,4.3-9.77A18.76,18.76,0,0,1,77.13,269.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.15,271.54l-5.87-3.73a14.43,14.43,0,0,0-3.54,2.81l5.77,3.65a10,10,0,0,1,1.25-1.17A18.7,18.7,0,0,1,70.15,271.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.05,252.58c.37,1.8-1,6.76-5.33,10S77,267.1,77,267.1l-1-.64s7.33-4.6,9.71-8.82.63-11,.63-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,267.1a21.25,21.25,0,0,1,7.34-10.36c5.49-3.89,9.76-4.16,9.76-4.16a12.73,12.73,0,0,0-7.81-5.91S80,250.36,77.59,256a22.24,22.24,0,0,0-1.69,10.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.07,255a24.2,24.2,0,0,1,3.77-1.68,19.94,19.94,0,0,0-7-5A25.41,25.41,0,0,0,80.11,252,14.78,14.78,0,0,1,87.07,255Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.34,264.3c-2.14,2.9-9.58,7.74-22.59,3.79l-.8-1.52s7.4.58,13.5-2.53,6.55-7.3,6.55-7.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,266.57a19,19,0,0,1,9-8.34,19.77,19.77,0,0,1,11-1.49s3.84,3,3.34,7.56a18.67,18.67,0,0,0-10.79-1.64c-6.2.9-11,3.7-11.8,5.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,262.56a18.71,18.71,0,0,1,4.43.94,13.53,13.53,0,0,0-4.3-7,21.59,21.59,0,0,0-2.78.23A12.82,12.82,0,0,1,94,262.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.14,284.33c-3.36.09-13.87-4.67-15-15.13l1.13-2.51s2.48,5.79,7.22,8.44,11.65,2.6,11.65,2.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,266.57s6-.14,10.12,1.52c7.28,3,9.74,6.41,10.06,9.64a12.14,12.14,0,0,1-5,6.6s-3-7.78-6.66-11.05c-4.9-4.37-8.35-4.08-8.35-4.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.24,282.22a23.79,23.79,0,0,0,5.43-6.35,10,10,0,0,0-3.42-4.37A14.38,14.38,0,0,1,87,274.93,36.34,36.34,0,0,1,91.24,282.22Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gift--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gift--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "143.13 420.11 95.8 392.75 95.8 351.78 94.8 351.2 94.8 337.25 143.13 365.15 143.13 420.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.13 379.1 125.01 368.64 95.8 351.78 95.8 353.78 143.13 381.11 143.13 379.1",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.13 420.11 190.2 392.95 190.2 351.92 191.46 351.2 191.46 337.25 143.13 365.15 143.13 420.11",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.2 351.92 143.13 379.1 143.13 381.11 190.2 353.95 190.2 351.92",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.46 337.25 143.13 309.35 94.8 337.25 143.13 365.15 191.46 337.25",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.75 408.79 162.75 353.82 170.61 349.29 170.61 404.26 162.75 408.79",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.5 408.79 123.5 353.82 115.65 349.29 115.65 404.26 123.5 408.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.5 408.79 123.5 353.82 115.65 349.29 115.65 404.26 123.5 408.79",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.61 349.29 122.28 321.39 114.43 325.92 162.75 353.82 170.61 349.29",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.77 342.86 151.62 338.33 143.77 333.8 135.92 338.33 143.77 342.86",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.5 353.82 171.83 325.92 163.98 321.39 115.65 349.29 123.5 353.82",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.25,325.61c.76,3.29,5.56,12.85,20.8,13.89l1.55-1.36s-17.7-4.43-13.86-19.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.78,341.3s0-9.37-3.56-14.9-10.48-8.2-10.48-8.2a21.91,21.91,0,0,0-8.49,7.41,28.77,28.77,0,0,1,12.25,3.11c6,3.16,8.55,10.78,8.55,10.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.35,328.65l6.17-3.25a20.28,20.28,0,0,0-3.49-3.5l-8.14,4.67A26.56,26.56,0,0,1,134.35,328.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.11,342.84s10.43,2.73,23.67-1.54l-1-1.8s-6.89,1.16-11.77,0-9-8.09-9-8.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.78,341.3s-.12-2.57-3.74-5.93c-4.75-4.41-14-4.41-18.07-4a8.2,8.2,0,0,0-3.12,5.13c-.49,2.51,1.26,6.3,1.26,6.3A15.22,15.22,0,0,1,132,337.39a14.93,14.93,0,0,1,10.62,3.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.73,331.46a36.08,36.08,0,0,0-4.63-.22,8.86,8.86,0,0,0-2.13,9,15.51,15.51,0,0,1,4.83-2.26A10.42,10.42,0,0,1,130.73,331.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.11,355s5.63-.69,9.18-4.76a19.85,19.85,0,0,0,4.49-8.92l-1.73-1.8a13.69,13.69,0,0,1-6.74,7c-4,1.77-11.45,1.75-11.45,1.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.78,341.3l-1.73-1.8s-6.69-1.35-10.3,0-7.81,7-7.89,8.72a10.57,10.57,0,0,0,6.25,6.76s-.34-6.16,4.3-9.77A18.72,18.72,0,0,1,144.78,341.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.8,343.64l-5.87-3.73a14.53,14.53,0,0,0-3.54,2.82l5.77,3.65a10,10,0,0,1,1.25-1.17A18.82,18.82,0,0,1,137.8,343.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.7,324.69c.37,1.8-.95,6.76-5.33,10s-11.77,4.48-11.77,4.48l-1-.63s7.33-4.61,9.71-8.82.63-11,.63-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6,339.2a21.25,21.25,0,0,1,7.34-10.35c5.49-3.89,9.76-4.16,9.76-4.16a12.69,12.69,0,0,0-7.81-5.91s-6.26,3.69-8.65,9.32a22.28,22.28,0,0,0-1.69,10.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.72,327.12a24,24,0,0,1,3.77-1.67,19.94,19.94,0,0,0-7-4.95,24.89,24.89,0,0,0-3.71,3.58A14.89,14.89,0,0,1,154.72,327.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,336.41c-2.15,2.9-9.58,7.73-22.59,3.79l-.8-1.52s7.4.58,13.5-2.54,6.55-7.29,6.55-7.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6,338.68a19,19,0,0,1,9-8.34,19.77,19.77,0,0,1,11.05-1.49s3.84,3,3.34,7.56a18.58,18.58,0,0,0-10.79-1.64c-6.2.9-11,3.7-11.8,5.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.62,334.66a19.76,19.76,0,0,1,4.43.94,13.61,13.61,0,0,0-4.3-7,20.18,20.18,0,0,0-2.79.23A12.69,12.69,0,0,1,161.62,334.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.79,356.44c-3.36.09-13.87-4.67-15-15.14l1.13-2.51s2.48,5.8,7.22,8.45,11.65,2.59,11.65,2.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6,338.68s6-.15,10.12,1.52c7.28,2.95,9.74,6.41,10.06,9.63a12.17,12.17,0,0,1-5,6.61s-3-7.78-6.66-11.05c-4.9-4.37-8.35-4.09-8.35-4.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.89,354.32a23.6,23.6,0,0,0,5.43-6.34,10.09,10.09,0,0,0-3.42-4.37,14.25,14.25,0,0,1-6.25,3.42A36.9,36.9,0,0,1,158.89,354.32Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gift--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gift--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 263.88 339.9 233.45 339.9 143.63 338.79 143 338.79 127.48 392.54 158.51 392.54 263.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 174.03 372.39 162.39 339.9 143.63 339.9 145.87 392.54 176.26 392.54 174.03",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 263.88 444.9 233.67 444.9 143.8 446.29 143 446.29 127.48 392.54 158.51 392.54 263.88",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.9 143.8 392.54 174.03 392.54 176.26 444.9 146.06 444.9 143.8",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.29 127.48 392.54 96.44 338.79 127.48 392.54 158.51 446.29 127.48",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.37 251.28 414.37 145.91 423.1 140.87 423.1 246.24 414.37 251.28",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.71 251.28 370.71 145.91 361.98 140.87 361.98 246.24 370.71 251.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.71 251.28 370.71 145.91 361.98 140.87 361.98 246.24 370.71 251.28",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.1 140.87 369.35 109.83 360.62 114.87 414.37 145.91 423.1 140.87",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.26 133.72 401.99 128.68 393.26 123.63 384.52 128.68 393.26 133.72",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.71 145.91 424.46 114.87 415.73 109.83 361.98 140.87 370.71 145.91",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.31,114.53c.86,3.66,6.19,14.29,23.14,15.45l1.72-1.51s-19.68-4.93-15.4-22.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.37,132s0-10.43-3.95-16.58-11.65-9.13-11.65-9.13a24.54,24.54,0,0,0-9.46,8.25A31.9,31.9,0,0,1,382.94,118c6.64,3.52,9.51,12,9.51,12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.77,117.91l6.87-3.61a22,22,0,0,0-3.88-3.89l-9.06,5.18A29.3,29.3,0,0,1,382.77,117.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.05,133.69s11.61,3,26.32-1.7l-1.11-2s-7.67,1.29-13.09,0-10.05-9-10.05-9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.37,132s-.13-2.86-4.16-6.6c-5.27-4.91-15.59-4.91-20.09-4.41a9.09,9.09,0,0,0-3.47,5.71c-.55,2.79,1.4,7,1.4,7a16.93,16.93,0,0,1,12.06-6,16.59,16.59,0,0,1,11.81,3.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.75,121a39.16,39.16,0,0,0-5.15-.25,9.88,9.88,0,0,0-2.37,10,17.39,17.39,0,0,1,5.38-2.52A11.53,11.53,0,0,1,378.75,121Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.18,147.19s6.26-.76,10.2-5.29a22,22,0,0,0,5-9.91l-1.92-2a15.19,15.19,0,0,1-7.49,7.75c-4.45,2-12.74,2-12.74,2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.37,132l-1.92-2s-7.44-1.5-11.45,0-8.7,7.77-8.78,9.7a11.75,11.75,0,0,0,7,7.51s-.39-6.84,4.77-10.86A20.84,20.84,0,0,1,394.37,132Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.62,134.59l-6.54-4.15a16.33,16.33,0,0,0-3.94,3.13l6.43,4.06a11.48,11.48,0,0,1,1.38-1.3A20.53,20.53,0,0,1,386.62,134.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.2,113.51c.41,2-1.06,7.51-5.93,11.15s-13.1,5-13.1,5L393,129s8.15-5.13,10.8-9.82.7-12.2.7-12.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.17,129.65a23.66,23.66,0,0,1,8.17-11.52c6.1-4.33,10.86-4.62,10.86-4.62a14.17,14.17,0,0,0-8.69-6.58s-7,4.11-9.62,10.37A24.83,24.83,0,0,0,393,129Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.44,116.21a27.39,27.39,0,0,1,4.19-1.86,22.18,22.18,0,0,0-7.82-5.51,29.07,29.07,0,0,0-4.12,4A16.6,16.6,0,0,1,405.44,116.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.2,126.54c-2.39,3.23-10.66,8.61-25.13,4.22l-.9-1.7s8.24.65,15-2.81,7.28-8.12,7.28-8.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.17,129.06a21.2,21.2,0,0,1,10-9.27,22,22,0,0,1,12.28-1.66s4.28,3.36,3.73,8.41a20.75,20.75,0,0,0-12-1.82c-6.89,1-12.27,4.12-13.12,6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.1,124.6a21.54,21.54,0,0,1,4.94,1.05,15.14,15.14,0,0,0-4.79-7.76,21.62,21.62,0,0,0-3.09.25C411.73,119.76,412.62,122.46,413.1,124.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.07,148.82c-3.74.1-15.43-5.19-16.7-16.83l1.26-2.8s2.76,6.45,8,9.4,13,2.88,13,2.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.17,129.06s6.67-.16,11.26,1.7c8.1,3.27,10.84,7.13,11.2,10.71a13.59,13.59,0,0,1-5.56,7.35s-3.32-8.65-7.41-12.29c-5.45-4.86-9.29-4.54-9.29-4.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.07,146.47a26.2,26.2,0,0,0,6-7.06,11.14,11.14,0,0,0-3.81-4.86,15.84,15.84,0,0,1-6.95,3.81A40.84,40.84,0,0,1,410.07,146.47Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gift--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gift--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "421.78 329.37 369.13 298.94 369.13 277.61 368.02 276.96 368.02 261.45 421.78 292.48 421.78 329.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.77 308 401.62 296.36 369.13 277.61 369.13 279.84 421.77 310.23 421.77 308",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.78 329.37 474.13 299.17 474.13 277.77 475.53 276.96 475.53 261.45 421.78 292.48 421.78 329.37",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.14 277.77 421.77 308 421.77 310.23 474.14 280.03 474.14 277.77",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.53 261.45 421.78 230.41 368.02 261.45 421.78 292.48 475.53 261.45",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.61 316.78 443.61 279.88 452.34 274.84 452.34 311.74 443.61 316.78",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.95 316.78 399.95 279.88 391.21 274.84 391.21 311.74 399.95 316.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.95 316.78 399.95 279.88 391.21 274.84 391.21 311.74 399.95 316.78",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.34 274.84 398.59 243.8 389.85 248.84 443.61 279.88 452.34 274.84",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.49 267.69 431.22 262.65 422.49 257.6 413.76 262.65 422.49 267.69",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.95 279.88 453.7 248.84 444.97 243.8 391.21 274.84 399.95 279.88",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M398.55,248.5c.85,3.66,6.18,14.29,23.13,15.45l1.73-1.51s-19.69-4.93-15.41-22.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.61,266s0-10.43-4-16.58S408,240.25,408,240.25a24.51,24.51,0,0,0-9.45,8.25A31.87,31.87,0,0,1,412.17,252c6.65,3.52,9.51,12,9.51,12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,251.88l6.86-3.61a21.65,21.65,0,0,0-3.88-3.89l-9.06,5.18A29.16,29.16,0,0,1,412,251.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.28,267.66s11.61,3,26.33-1.7l-1.12-2s-7.67,1.29-13.09,0-10-9-10-9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.61,266s-.14-2.86-4.16-6.6c-5.28-4.91-15.59-4.91-20.1-4.41a9.14,9.14,0,0,0-3.47,5.71c-.54,2.79,1.4,7,1.4,7a17,17,0,0,1,12.06-6.05,16.57,16.57,0,0,1,11.81,3.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,255a39,39,0,0,0-5.15-.25,9.9,9.9,0,0,0-2.37,10,17.39,17.39,0,0,1,5.38-2.52A11.6,11.6,0,0,1,408,255Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.41,281.16s6.26-.76,10.21-5.29a22,22,0,0,0,5-9.91l-1.93-2a15.15,15.15,0,0,1-7.48,7.75c-4.45,2-12.74,1.95-12.74,1.95Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.61,266l-1.93-2s-7.43-1.5-11.45,0-8.69,7.77-8.77,9.7a11.73,11.73,0,0,0,7,7.51s-.38-6.84,4.78-10.86A20.81,20.81,0,0,1,423.61,266Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.85,268.56l-6.53-4.15a16.33,16.33,0,0,0-3.94,3.13l6.42,4.06a13.21,13.21,0,0,1,1.38-1.3A20.53,20.53,0,0,1,415.85,268.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.43,247.48c.41,2-1.05,7.51-5.93,11.15s-13.09,5-13.09,5l-1.17-.7s8.16-5.13,10.8-9.81.7-12.21.7-12.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.41,263.62a23.68,23.68,0,0,1,8.16-11.52c6.11-4.33,10.86-4.62,10.86-4.62a14.11,14.11,0,0,0-8.69-6.58s-7,4.11-9.61,10.37a24.92,24.92,0,0,0-1.89,11.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.67,250.18a27.39,27.39,0,0,1,4.19-1.86,22.22,22.22,0,0,0-7.81-5.51,28.53,28.53,0,0,0-4.12,4A16.51,16.51,0,0,1,434.67,250.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.43,260.51c-2.39,3.23-10.65,8.61-25.13,4.22l-.89-1.7s8.23.65,15-2.81,7.29-8.12,7.29-8.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.41,263a21.21,21.21,0,0,1,10-9.27,22,22,0,0,1,12.29-1.66s4.28,3.36,3.72,8.41a20.72,20.72,0,0,0-12-1.82c-6.89,1-12.27,4.12-13.12,6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.34,258.57a22.05,22.05,0,0,1,4.93,1,15.07,15.07,0,0,0-4.78-7.75,21.75,21.75,0,0,0-3.1.25C441,253.73,441.85,256.43,442.34,258.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.31,282.79c-3.74.1-15.43-5.19-16.7-16.83l1.26-2.8s2.75,6.45,8,9.4,13,2.88,13,2.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.41,263s6.66-.16,11.25,1.7c8.11,3.27,10.84,7.13,11.2,10.71a13.57,13.57,0,0,1-5.55,7.35s-3.33-8.65-7.41-12.29c-5.45-4.86-9.29-4.54-9.29-4.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.3,280.44a26.44,26.44,0,0,0,6.05-7.06,11.29,11.29,0,0,0-3.81-4.86,15.9,15.9,0,0,1-7,3.81A40.76,40.76,0,0,1,439.3,280.44Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.29,417.47c.82-3.49-2.65-5.7-4.29-7.71-2.53-3.1-3.31-10.33-3.29-14,0-4.61-.52-7.89,2.35-12.06,3.39-4.92,8.12-10.7,23.92-24.82L80.51,339.3c-4.07,6.39-14.35,28.77-14.35,28.77l-.68,1.39a25.57,25.57,0,0,1-6.13,5.87l-1.08.55c-1.86,1.27-6.58,2.61-6.5,7s1.8,5.5,3.8,9.11c1.27,2.31,2.2,3.48,2.29,7.88.08,3.55-.07,7.51-.11,10.69,0,2.68,2.44,6.56,7.59,8.3C72.84,421.43,80.48,420.9,81.29,417.47Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1,383a49.6,49.6,0,0,0-5.62,9.68L48.65,400l4.34-7.3A26.4,26.4,0,0,1,49.1,383Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.65,400l7.1-.48a6,6,0,0,0-.7-4.38A9.08,9.08,0,0,0,53,392.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.53,381.4a5.17,5.17,0,0,0-1.37,1.47c-.34.72,0,5.26,1.52,7.46s3.88,4.54,4.47,7.67-.65,10.36.6,14.73,5.47,9.38,14.68,10.56c6.58.85,9.07-.4,11.27-1.77.79-2.84.72-3.58-2.88-6S50.53,381.4,50.53,381.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.79,369.84c-3,3.51-4,4.86-6.73,6.43-3.29,1.91-4,2.67-5.53,5.13-.67,3.79.1,5.36,3.58,10.21,2.39,3.32,3.17,5.5,3.1,10.06-.08,5.53-2,10.56,4.77,16.21,5.24,4.4,16.7,4.7,19.81,1.64,2.67-7.54-4.42-7.14-6-15.13-.89-4.42-1-11.1.42-15.51a35.56,35.56,0,0,1,2.33-5.79c1.1-1.88,2.08-3.24,1.19-4.23L78,380.92c-1.67.36-5.7-.51-8.36-2.65-6.41-5.16-4.18-8.81-4.18-8.81l.68-1.39C65.51,367.29,64.46,367.85,62.79,369.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.05,193.92c1.61,10.88,6.86,24.53,9.77,50.3,2.73,24.16,4,36.77,2.22,48.78-.62,4.28-2.82,9.3-7,15.64-13.19,19.85-39.14,51.08-39.14,51.08s-5.89-.09-13-5.77a19.84,19.84,0,0,1-7.19-13.6s.7-4.54,11.58-22.83,12.27-38.08,12.27-38.08l-7.09-77.6C113.31,203.34,126.17,200.25,134.05,193.92Z",
    style: {
      fill: "#263238"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.85,354a19.84,19.84,0,0,1-7.19-13.6s.7-4.54,11.58-22.83,12.27-38.08,12.27-38.08L98.08,220c13.22-2,31.67-1.88,31.67-1.88.35,8.5-1.54,19-13.78,25.37,0,0,2.25,41.78,2.54,54,.22,9.32-2.5,33.07-3.8,43.81-8.24,10.42-14.84,18.37-14.84,18.37S94,359.63,86.85,354Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.24,398.65l.09-1.88,1.84-38.15-26.85,6.7,6,30.59.2,1.59s.29,7.77,12.28,8.22C108.91,405.94,109.24,398.65,109.24,398.65Z",
    style: {
      fill: "#ffbda7"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "94.74 433.44 104.06 429.98 104.36 421.13 94.88 424.71 94.74 433.44"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.68,413.59c-.39,3.25,2.29,15.75,2.29,15.75l6.77,4.1.14-8.73s1.88,1.6,3.86,6.22c1.88,4.36,4.46,8.56,8.89,10.76s12.08,3.11,18.58,2.27c4.62-.61,7.47-2.58,8.24-3.76a4,4,0,0,0,.27-1.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.33,396.77c1.27-.1,1.17,1.12,2.75,8.44,1.17,5.47,3.74,14.9,13.7,21.12,4.1,2.56,9.77,4.19,8.94,12-2.84,3.8-12.76,4.81-18.7,3.76-12-2.12-13.78-6.85-16.78-13.9-2.4-5.66-4.51-6.26-7.72-8.53-2.12-1.5-5-3.66-5.84-6.1-.15-5.38,1.87-8.89,2.6-11.6.68-2.55.29-5.69,2-6.08l.2,1.59s1.61,4.31,10,4.47,8.8-3.32,8.8-3.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.05,193.92s2.14,14.06-2.44,26.87c-4,11.13-11.61,17.4-19.65,20,0,0,2.67,50,3.38,56.93s-1,32.17-2.46,48.76-2,22.27-2,22.27-3.55,3.74-13.48,3.93-13.07-3.9-13.07-3.9-6.28-19.18-6.54-34.23c-.15-8.63,1.74-12.92.1-21.47s-13.77-46.62-15.82-64.67S63.13,214.51,76,196C89.8,205.05,121.47,202.78,134.05,193.92Z",
    style: {
      fill: "#263238"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.64,198.82c-7,9.6-17,29.4-9.87,57.77,2,8.06,4,15.84,6,23.37,4.57,17.63,8.18,31.55,8.67,36.87a42.33,42.33,0,0,1-.44,9,75,75,0,0,0,0,21.09C87.24,356,89.05,365.5,90.36,372c-.42-.11-.82-.22-1.19-.35-1.3-6.45-3-15.74-4.26-24.59a76.09,76.09,0,0,1,0-21.34,41.9,41.9,0,0,0,.44-8.75c-.48-5.24-4.09-19.12-8.64-36.71-2-7.53-4-15.31-6-23.38-7.17-28.57,2.83-48.6,9.89-58.43Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180,167.28c4.52,1.66,7.67.73,11,.81,4.23.1,7.83,1.43,13.83,2.83l3.07.74a11.51,11.51,0,0,0,1.5.33c.48,0,.88.12,1,.72a1.8,1.8,0,0,1-.33,1.22,5.18,5.18,0,0,1-3.62,2.07,25.47,25.47,0,0,1-4.28.05c-1.1,0-.37,1,0,1.42,2,2.11,10.13,2.41,12.9,3.15,1.26.34,2.77,0,3.3,1.48a8,8,0,0,0,.54,1.46,6.06,6.06,0,0,0,1.14,1.18,3.58,3.58,0,0,1,1.15,2.11,2.08,2.08,0,0,1-1,2.08c-.57.29-1.3.25-1.82.63a6.45,6.45,0,0,0-.62.66c-1,1-2.49.88-3.83,1.1-1.16.2-2.15.78-3.28,1a23.27,23.27,0,0,1-3.61.61,44.44,44.44,0,0,1-8.55-.49A29.49,29.49,0,0,1,188,187.93a19.07,19.07,0,0,0-8.69-3.79c-5.39-1.13-26-4.58-33.72-8-2.8-1.26-4.41-2.9-13.85-9.3-14-9.5-36.14-26.15-36.14-26.15l10.21-14.43c9.75-2.16,20.14,6.85,26.5,12.12C144,148,153,154.56,153,154.56S176.15,165.87,180,167.28Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.05,177.36c-3.16,3.4-9.32,3.16-12.05,2.23,0,0,3.82,2.34,6.94,1.69C197.35,180.58,198.37,179.13,199.05,177.36Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.07,171.72S67.4,166.5,68.83,155c.65-5.22-.23-10.78-2.45-18.64l14.81-4.82S83,129.36,94,127.35l11.88-1.12s19.79,9.7,27.24,19.47c4.06,5.33,8.27,16.7,1.12,25.34.56,7.73.66,23.5.66,23.5s-4.2,7.62-24.41,9.92c-29,3.31-37.07-7.25-37.07-7.25C72.82,188.91,65.12,179.69,62.07,171.72Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.07,171.72S67.4,166.5,68.83,155c.65-5.22-.23-10.78-2.45-18.64l14.81-4.82S83,129.36,94,127.35l11.88-1.12s19.79,9.7,27.24,19.47c4.06,5.33,8.27,16.7,1.12,25.34.56,7.73.66,23.5.66,23.5s-4.2,7.62-24.41,9.92c-29,3.31-37.07-7.25-37.07-7.25C72.82,188.91,65.12,179.69,62.07,171.72Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68,173.73s-4.18,7.08-15.4,6.81-14.56-8.22-14.56-8.22.87,10.73,14.27,11C110.19,183.58,112.68,173.73,112.68,173.73Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.7,73.75a11.78,11.78,0,0,1,6.23-3.91c2.33-.58,3.76-.55,6-1.46s3.93-2.34,6-3.23c4.64-2,10.24-.74,14.23,2.34,1.76,1.36,3.41,3.12,5.62,3.45a22.63,22.63,0,0,0,3.29,0c3.48,0,6.69,2.26,8.53,5.21a17.9,17.9,0,0,1,2.43,7.71c.28,2.69-.66,5.19-.49,7.87.12,2,1.34,3.69,2.54,5.17,1.62,2,2.94,3.52,3.74,6.05a12.45,12.45,0,0,1,.59,6,6.1,6.1,0,0,1-3.62,4.61,6.18,6.18,0,0,0-.79-5.79,7,7,0,0,1-1,5.31,14.51,14.51,0,0,1-3.92,3.89,20.42,20.42,0,0,1-11.72,4.27c-4.45,0-9-1.51-13.36-.35a34.35,34.35,0,0,0-3.56,1.29,31.76,31.76,0,0,1-6.27,1.69c-2,.33-4.12.18-6.15.47a13.32,13.32,0,0,1-9.53-2.25,15,15,0,0,1-5.76-11.69,7,7,0,0,0-1.36,3.33,9.7,9.7,0,0,1-1.91-8.58c.62-2.33,2.1-4.42,2.28-6.81.15-2.07-.7-4.08-.93-6.15a10.6,10.6,0,0,1,7.55-11A9.73,9.73,0,0,1,71.7,73.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.76,99.79c2.83-1.19,5.3-.2,6.93,2.76,1.43,2.57,4.22,1.56,3.41-2.5,6.25-6.35-1.39-10,3.74-16.14,3.19-3.81,10.31-3.06,13.22-.84A7,7,0,0,1,107,79.59c3,1,5,2.66,6.54,6.74,1.63,4.25.12,5.11.94,8.13.32,1.16,1.58,3.44,1.73,6.44.71,14.22-2.13,17.91-5.19,20.35-2.1,1.68-4.82,2.63-9.51,2.83l.44,6.2A31.9,31.9,0,0,1,109,146.86c-13.54-3.47-20.58-8-28.5-14l-1.35-20.62h0c-.61,1.64-3.86,3.53-7.27.93C67.57,109.86,66.75,101.89,71.76,99.79Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,92.78l-4.62-1.71a2.36,2.36,0,0,1,3.08-1.51A2.6,2.6,0,0,1,112,92.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,91.63l-4.24,2.5a2.36,2.36,0,0,1,.78-3.34A2.58,2.58,0,0,1,94,91.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.48,108.57l6.89,2.14A3.62,3.62,0,0,1,98.52,113C96.64,112.3,96,110.51,96.48,108.57Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.51,113.15a3.79,3.79,0,0,0-3.84-3.33,2,2,0,0,0-.35.05,3.16,3.16,0,0,0,2.2,3.09A4.17,4.17,0,0,0,100.51,113.15Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.68 93.98 102.18 106.69 109.14 104.06 100.68 93.98",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.48,97.66a2.06,2.06,0,1,1-2.2-1.92A2.06,2.06,0,0,1,95.48,97.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.51,96.76a2.06,2.06,0,1,1-2.2-1.92A2.06,2.06,0,0,1,111.51,96.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.49,124.08C96.92,124,89.16,124,85.24,119c0,0,.58,3,5.31,5.25,3.33,1.56,11.07,2,11.07,2Z",
    style: {
      fill: "#f0997a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.42,239.9c-1.35-1.46-3.07-2.75-3.63-4.74a3.39,3.39,0,0,1,.48-3,1.42,1.42,0,0,0,.36-.55,1.23,1.23,0,0,0,0-.54,3.77,3.77,0,0,1,.14-2.26,2.33,2.33,0,0,1,1.44-1.22,5.52,5.52,0,0,1,0-3.41c.45-1.3,1.79-2.33,2.66-.88a12.73,12.73,0,0,1,1,2.26,27.19,27.19,0,0,1,1.29,6.05c.21,2.14.73,8.21-2.59,8.49C57.34,240.1,56.6,240.11,56.42,239.9Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.35,136.35c-14.48,4.13-16.84,11-24.45,21.48s-13.21,17.9-16.37,23.71c-3.32,6.12-3.66,8.58,3.49,16.4,3.72,4.07,8.22,8.11,15,14.17,3,2.69,11.24,9.84,12.47,11A13.14,13.14,0,0,1,59,228.21a4,4,0,0,1,.1.77,20.5,20.5,0,0,1-.39,3.29,16.62,16.62,0,0,0,.17,4.4c.18,1.22.5,2.4-.87,3a3.3,3.3,0,0,1-1.62.19,11.41,11.41,0,0,0,3.12,1.7,4.75,4.75,0,0,0,3.48-.11,37,37,0,0,1,4.13-1.83c.6-.18,1.24-.15,1.84-.31a3,3,0,0,0,1.58-1c.63-.79.89-1.94,1.78-2.42a13.25,13.25,0,0,1,1.39-.45,3.11,3.11,0,0,0,1.71-2.29,8.42,8.42,0,0,0-.07-3c-.4-2.63-.85-5.5-1.5-8.09a18.33,18.33,0,0,0-3.16-7c-4.44-6.21-21.34-27.4-21.34-27.4l14.34-17.51C67.13,167.49,75,147.41,66.35,136.35Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.38,187.73c-3.89,3.81-9.91,4.12-12.14,4a13.56,13.56,0,0,0,13.68-2.05Z",
    style: {
      fill: "#f0997a"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--mobile--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.58,350.55,319.2,51.76c-.52-7.69-4.79-9.72-8.58-11.6s-9.89-2.94-14.9,0l-128.24,74c-5,2.89-8.76,9.75-8.38,15.31l20.37,298.79c.38,5.57,4.37,8.77,8.16,10.65s10.32,3.89,15.33,1l128.24-74C336.21,363,340.11,358.3,339.58,350.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.31,353.56,199.44,429.69,179,129.61l-17.75-8.81a16.31,16.31,0,0,0-2.17,8.66l20.37,298.79c.38,5.57,4.37,8.77,8.16,10.65s10.32,3.89,15.33,1l128.24-74a16,16,0,0,0,7.57-8.6l-.55-.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.37,49.38,180.76,123.64a12.68,12.68,0,0,0-5.89,10.74l20.21,296.36c.41,6,5.16,8.32,10.54,5.21L330.8,363.68c4-2.3,7-7.77,6.67-12.18L317.13,53.23C316.83,48.82,313.33,47.09,309.37,49.38Z",
    style: {
      fill: "#455a64"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M330.47,344.56c.29,4.21-2.56,9.41-6.33,11.58L208.2,423.08c-3.78,2.2-7.08.56-7.36-3.65l-19-279.07a13.62,13.62,0,0,1,4.31-10c.22-.19.42-.39.64-.57a10.28,10.28,0,0,1,1.38-.95L220.74,110l2.13-1.23c1.17-.68,2.2-.17,2.29,1.14s1.17,1.78,2.43,1L265.6,89a4.39,4.39,0,0,0,2.11-3.66,4.29,4.29,0,0,1,1.74-3.47l.22-.14,41.25-23.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.31,349c3.77-2.17,6.62-7.37,6.33-11.58L301,63.65l-31.3,18.06-.22.14a4.29,4.29,0,0,0-1.74,3.47A4.39,4.39,0,0,1,265.6,89l-38,21.94c-1.26.74-2.34.26-2.43-1s-1.12-1.82-2.29-1.14L220.74,110l-39.45,22.78,19.18,281.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.89,165.05a7.71,7.71,0,0,0-3.88-5.76,2.47,2.47,0,0,0-2.4-.13c-.42.25-2.07,1.17-2.51,1.44a2.34,2.34,0,0,0-.92,2.31l1.66,24.34a7.71,7.71,0,0,0,3.88,5.76,2.52,2.52,0,0,0,2.31.18c.47-.24,2.16-1.22,2.6-1.48a2.34,2.34,0,0,0,.92-2.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.39,166.48l1.67,24.35c.14,2.19-1.35,3.17-3.34,2.18a7.71,7.71,0,0,1-3.88-5.76l-1.66-24.34c-.15-2.19,1.35-3.17,3.34-2.18A7.66,7.66,0,0,1,171.39,166.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.79,207.66a7.72,7.72,0,0,0-3.87-5.76,2.47,2.47,0,0,0-2.4-.13c-.42.25-2.08,1.17-2.51,1.44a2.32,2.32,0,0,0-.92,2.31l1.66,24.34a7.67,7.67,0,0,0,3.88,5.76,2.52,2.52,0,0,0,2.31.18c.46-.24,2.16-1.22,2.59-1.48a2.34,2.34,0,0,0,.92-2.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.3,209.1,176,233.44c.15,2.19-1.34,3.17-3.33,2.18a7.67,7.67,0,0,1-3.88-5.76l-1.66-24.34c-.15-2.19,1.34-3.17,3.33-2.18A7.69,7.69,0,0,1,174.3,209.1Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Awning--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "181.29 132.75 310.93 57.9 350.46 83.44 220.82 158.29 181.29 132.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.29 132.75 220.82 158.29 235.22 149.97 195.69 124.43 181.29 132.75",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.1 116.12 249.63 141.66 264.03 133.34 224.5 107.8 210.1 116.12",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.91 99.48 278.44 125.02 292.84 116.71 253.31 91.17 238.91 99.48",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.72 82.85 307.25 108.39 321.65 100.07 282.12 74.53 267.72 82.85",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.53 66.22 336.06 91.76 350.46 83.44 310.93 57.9 296.53 66.22",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.82,158.29c0,4.59,3.22,6.46,7.2,4.16a15.92,15.92,0,0,0,7.2-12.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.63,141.66c0,4.59,3.22,6.45,7.2,4.16A15.94,15.94,0,0,0,264,133.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.44,125c0,4.6,3.23,6.46,7.2,4.16a15.92,15.92,0,0,0,7.21-12.47Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.25,108.39c0,4.59,3.23,6.45,7.2,4.16a15.94,15.94,0,0,0,7.21-12.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.06,91.75c0,4.6,3.23,6.46,7.21,4.16a15.92,15.92,0,0,0,7.2-12.47Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M220.82,158.29c0,4.59,3.22,6.46,7.2,4.16a15.92,15.92,0,0,0,7.2-12.48Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M249.63,141.66c0,4.59,3.22,6.45,7.2,4.16A15.94,15.94,0,0,0,264,133.34Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M278.44,125c0,4.6,3.23,6.46,7.2,4.16a15.92,15.92,0,0,0,7.21-12.47Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M307.25,108.39c0,4.59,3.23,6.45,7.2,4.16a15.94,15.94,0,0,0,7.21-12.48Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M336.06,91.75c0,4.6,3.23,6.46,7.21,4.16a15.92,15.92,0,0,0,7.2-12.47Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M235.22,150c0,4.6,3.23,6.46,7.21,4.16a15.92,15.92,0,0,0,7.2-12.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,133.34c0,4.59,3.23,6.45,7.21,4.16a15.92,15.92,0,0,0,7.2-12.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.85,116.71c0,4.59,3.22,6.45,7.2,4.15a15.9,15.9,0,0,0,7.2-12.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.66,100.07c0,4.59,3.22,6.46,7.2,4.16a15.92,15.92,0,0,0,7.2-12.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gift--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gift--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gift--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "310.14 328.66 383.39 286.32 383.39 234.27 384.94 233.38 384.94 211.78 310.14 254.97 310.14 328.66",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "310.14 328.66 383.39 286.32 383.39 234.27 384.94 233.38 384.94 211.78 310.14 254.97 310.14 328.66",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "310.14 276.56 338.19 260.37 383.39 234.27 383.39 237.38 310.14 279.66 310.14 276.56",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.14 328.66 237.29 286.63 237.29 234.5 235.34 233.38 235.34 211.78 310.14 254.97 310.14 328.66",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.14 328.66 237.29 286.63 237.29 234.5 235.34 233.38 235.34 211.78 310.14 254.97 310.14 328.66",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.28 234.5 310.14 276.56 310.14 279.66 237.28 237.64 237.28 234.5",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.34 211.78 310.14 168.6 384.94 211.78 310.14 254.97 235.34 211.78",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "235.34 211.78 310.14 168.6 384.94 211.78 310.14 254.97 235.34 211.78",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "279.76 311.13 279.76 237.43 267.61 230.42 267.61 304.12 279.76 311.13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.76 311.13 279.76 237.43 267.61 230.42 267.61 304.12 279.76 311.13",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.76 311.13 279.76 237.43 267.61 230.42 267.61 304.12 279.76 311.13",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.52 311.13 340.52 237.43 352.67 230.42 352.67 304.12 340.52 311.13",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.52 311.13 340.52 237.43 352.67 230.42 352.67 304.12 340.52 311.13",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.61 230.42 342.41 187.23 354.56 194.25 279.76 237.43 267.61 230.42",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.15 220.47 297 213.45 309.15 206.44 321.3 213.45 309.15 220.47",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.52 237.43 265.72 194.25 277.87 187.23 352.67 230.42 340.52 237.43",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "307.22 218.44 324.42 246.74 324.42 296.05 335.06 281.01 335.06 240.64 309.71 213.23 307.22 218.44",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.17 215.47 359.72 217 368.27 205.48 310.06 210.72 310.17 215.47",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.12,193.12s3,12,16.93,16.63,30.07,5.73,30.07,5.73l-31.65-37.77Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.12,193.12s3,12,16.93,16.63,30.07,5.73,30.07,5.73l-31.65-37.77Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.12,215.48s.34-11.83-5.77-20.77-25.88-17-25.88-17a84.14,84.14,0,0,0-15.35,15.41s26.28-.21,44.34,21.95Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.12,215.48s.34-11.83-5.77-20.77-25.88-17-25.88-17a84.14,84.14,0,0,0-15.35,15.41s26.28-.21,44.34,21.95Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.61,196.16a61.46,61.46,0,0,1,13.94,6.56l9.63-9.51c-3.21-3.75-8.52-7.25-13.41-10Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.12,215.48a28.55,28.55,0,0,1-13,12.15c-9.5,4.61-25.4,4.37-25.4,4.37l-1.52-20a20,20,0,0,0,16.75,9,29.41,29.41,0,0,0,19.45-7.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.12,215.48a28.55,28.55,0,0,1-13,12.15c-9.5,4.61-25.4,4.37-25.4,4.37l-1.52-20a20,20,0,0,0,16.75,9,29.41,29.41,0,0,0,19.45-7.17Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.12,215.48c-9.95-10.14-19.26-11.12-27.75-9.14-9.4,2.2-12.18,5.63-12.18,5.63l1.52,20s5-9.78,18.58-14.18S309.12,215.48,309.12,215.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.12,215.48c-9.95-10.14-19.26-11.12-27.75-9.14-9.4,2.2-12.18,5.63-12.18,5.63l1.52,20s5-9.78,18.58-14.18S309.12,215.48,309.12,215.48Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.85,208.88c2.31,3.32,6,8.75,8.31,12.18a36.3,36.3,0,0,1,7.13-3.24,64.8,64.8,0,0,1,7.18-1.87l-8.64-10.44a30.24,30.24,0,0,0-6.46.83A38,38,0,0,0,273.85,208.88Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.56,213.25s14-2,23.67-12.38S344,176,344,176l-17.62-11a32.84,32.84,0,0,1-3.15,27.21c-6.27,10.7-15,12.89-15,12.89Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.56,213.25s14-2,23.67-12.38S344,176,344,176l-17.62-11a32.84,32.84,0,0,1-3.15,27.21c-6.27,10.7-15,12.89-15,12.89Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.56,213.25l2.58-.53a45.21,45.21,0,0,1,13.8-26.44C337.78,174.52,344,176,344,176c-5.16-5.18-11.26-8.38-17.62-11,0,0-10.92,6.38-15.75,15.41C304.84,191.22,306.74,207.24,308.56,213.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.56,213.25l2.58-.53a45.21,45.21,0,0,1,13.8-26.44C337.78,174.52,344,176,344,176c-5.16-5.18-11.26-8.38-17.62-11,0,0-10.92,6.38-15.75,15.41C304.84,191.22,306.74,207.24,308.56,213.25Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.56,179l-14.87-9.15c-.71.59-1.42,1.21-2.15,1.89l14.52,8.85C332.94,180,333.78,179.44,334.56,179Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.85,182.16l-14.38-8.35a33.92,33.92,0,0,0-3.71,4.68l-.1.14c-.37.57-.72,1.16-1,1.75-.18.35-.3.75-.47,1.11l12,7.57c.85-.94,1.76-1.87,2.75-2.78C326.71,184.66,328.33,183.32,329.85,182.16Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M309,215.46s4.52,4.51,15.13,6.81,23.87.29,29.4-6.21l-1.76-18.58s-8.48,12.2-21.29,14.64c-9.76,1.85-21.61-1.66-21.61-1.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,215.46s4.52,4.51,15.13,6.81,23.87.29,29.4-6.21l-1.76-18.58s-8.48,12.2-21.29,14.64c-9.76,1.85-21.61-1.66-21.61-1.66Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.25,211.2s9.87-11,20.82-13c14.83-2.73,22.74-.72,22.74-.72,2.84,6.63,3.34,12.81,1.76,18.58,0,0-6.65-6.72-21.75-6.8-11.94-.06-22.78,6.2-22.78,6.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.25,211.2s9.87-11,20.82-13c14.83-2.73,22.74-.72,22.74-.72,2.84,6.63,3.34,12.81,1.76,18.58,0,0-6.65-6.72-21.75-6.8-11.94-.06-22.78,6.2-22.78,6.2Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.35,213.79a33.65,33.65,0,0,0-10.57-3.74l-2.34-13a63.23,63.23,0,0,1,11.1-.08A43.26,43.26,0,0,1,350.35,213.79Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.06 240.64 324.42 246.74 324.42 296.05 335.06 281.01 335.06 240.64",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.72,286.93c-.87,2-5.53,1-7.2,1a4.18,4.18,0,0,0-1.32.14,5.35,5.35,0,0,0-1.41.85,11.06,11.06,0,0,1-7.36,1.5c-2.72-.25-6.32-2.14-8.78-.66s-5.84.81-8.69-.11a96.3,96.3,0,0,1-14.38-5.94c-3-1.52-5.75-3.24-8.52-5l-.71-.47c-3-1.94-6.15-3.53-9.1-5.54-6-4.1-11.61-8.64-17.82-12.37-1.91-1.15-4.14-2.41-6.61-3.75h0l-.87-.47-.08-.06c-1.85-1.31-3-4-3-7.65,0-7.19,4.37-15.54,9.77-18.66,2.53-1.47,4.84-1.51,6.58-.39l.81.63a98.53,98.53,0,0,0,10.24,7.28c9.48,5.27,13.41,5.2,19.4,4.89,3.83-.19,7.6.25,11.42.33,4.84.11,9.72.23,14.59.28a1.56,1.56,0,0,1,1.15.33,1.42,1.42,0,0,1,.3.67c.5,2,.07,3.13-1.55,4.45-2.49,2-6,3-9.15,3.48-1.41.23-5.63.33-6.27,2-.45,1.18,1.79,2.77,2.67,3.31,4.93,3,10.8,4.84,16.15,7,2.93,1.2,5.84,2.43,8.7,3.78,3.69,1.74,9.35,3.61,9.91,8.33a.94.94,0,0,1-.06.6,1,1,0,0,1-.62.42,8.8,8.8,0,0,1-3.79.11c-1.79-.23-3.56-.59-5.33-.94s-3.08-.71-5.12-1.25c-1.45-.38-3.41-1.08-5.15-1.39,0,0,11.33,5.09,16.38,7.21a9.87,9.87,0,0,1,4.06,2.54A3.78,3.78,0,0,1,297.72,286.93Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.5,273.63c-5.54-1.91-13.14-4.53-15.06-5.65C264.83,270.52,271.22,272.61,276.5,273.63Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,287.1c-4.68-1.41-9.32-3.05-13.88-4.82-2.3-.9-4.59-1.84-6.87-2.79s-4.44-2-6.67-3c0,0-.07.08,0,.1A105.54,105.54,0,0,0,274,282.81,128.39,128.39,0,0,0,288,287.27C288.05,287.29,288.07,287.11,288,287.1Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,288.65c-3.65-1.25-7.27-2.73-10.83-4.35-1.81-.82-3.59-1.69-5.38-2.56s-3.47-1.87-5.22-2.8c0,0,0,.08,0,.1a73.13,73.13,0,0,0,10.56,5.79,81.67,81.67,0,0,0,10.87,4C274.06,288.85,274.08,288.67,274,288.65Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.52,230.43a28.4,28.4,0,0,0-3.16,4.17,25.8,25.8,0,0,0-2.23,4.83,27.81,27.81,0,0,0-1.2,4.92,23.24,23.24,0,0,0-.06,5.59c0,.07.06,0,.06,0a31,31,0,0,1,.4-4.9,28,28,0,0,1,1.18-5.1,28.54,28.54,0,0,1,5.08-9.33C205.63,230.54,205.59,230.36,205.52,230.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.44,259.11a7.85,7.85,0,0,1-3.4-.36,7.31,7.31,0,0,1-2.84-2,9.64,9.64,0,0,1-1.82-3.38,15.83,15.83,0,0,1-.53-2.16,23.61,23.61,0,0,0-.42-2.35s-.06,0-.06,0a9.9,9.9,0,0,0,.51,4.21,10.53,10.53,0,0,0,1.91,3.83,7.89,7.89,0,0,0,3.08,2.31,4.77,4.77,0,0,0,3.68.24C205.68,259.37,205.57,259.1,205.44,259.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.4,228.57a7.85,7.85,0,0,0-7.14-4.54c-3.72-.07-7.29,2-9.81,4.53a21,21,0,0,0-3.86,5.42c0,.06,0,.26.09.16,3-4.77,5.47-7.28,9.84-8.91,3.74-1.38,8.82-.44,10.69,3.46C220.3,228.87,220.46,228.72,220.4,228.57Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.85,82.58a28.78,28.78,0,0,1-20,7.12l-3.29-.3A28.87,28.87,0,0,1,164.39,32l3.3.14a28.86,28.86,0,0,1,16.16,50.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.4,40.2a31.33,31.33,0,0,0-50.25,37.07l-4.51,8.63a1.81,1.81,0,0,0,2.23,2.55L145,85.12A31.33,31.33,0,0,0,188.4,40.2Zm-4.55,42.38a28.78,28.78,0,0,1-20,7.12l-3.29-.3A28.87,28.87,0,0,1,164.39,32l3.3.14a28.86,28.86,0,0,1,16.16,50.46Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Heart--inject-6",
    d: "M164.83,76.18c-20.39-10.86-22-22.52-16.11-28.21,5.31-5.11,15-1.74,16.11,5.55,1.08-7.29,10.79-10.66,16.1-5.55C186.85,53.66,185.21,65.32,164.83,76.18Z",
    style: {
      fill: "#BA68C8"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.87,401.34a8.33,8.33,0,0,1-3.89,6.45L267.8,474.87a8.6,8.6,0,0,1-7.78,0l-28.68-16.56a7.3,7.3,0,0,1,0-12.91l116.18-67.08a8.6,8.6,0,0,1,7.78,0L384,394.88A8.33,8.33,0,0,1,387.87,401.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.87,401.34a8.33,8.33,0,0,1-3.89,6.45L267.8,474.87a8.6,8.6,0,0,1-7.78,0l-28.68-16.56a7.3,7.3,0,0,1,0-12.91l116.18-67.08a8.6,8.6,0,0,1,7.78,0L384,394.88A8.33,8.33,0,0,1,387.87,401.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.57,395.28c1.54,1.25,1.34,3-.59,4.09l-48.43,28L267.8,466.45a7.94,7.94,0,0,1-3.89.93v8.42a8,8,0,0,0,3.89-.92L384,407.79a7.26,7.26,0,0,0,.58-12.51Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,466.45l-28.68-16.56c-2.15-1.24-2.15-3.25,0-4.49l116.18-67.08a8.6,8.6,0,0,1,7.78,0L384,394.88c2.15,1.24,2.15,3.25,0,4.49l-48.43,28L267.8,466.45A8.6,8.6,0,0,1,260,466.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.41,378.8h0a6.62,6.62,0,0,1,3.19.74l28.68,16.56c.56.32.91.72.91,1s-.35.7-.91,1l-48.43,28-67.76,39.12a7.2,7.2,0,0,1-6.36,0L232,448.68c-.56-.33-.91-.72-.91-1s.35-.71.91-1l116.19-67.08a6.56,6.56,0,0,1,3.18-.74m0-1.41a8,8,0,0,0-3.89.93L231.34,445.4c-2.15,1.24-2.15,3.25,0,4.49L260,466.45a8.6,8.6,0,0,0,7.78,0l67.75-39.12,48.43-28c2.15-1.24,2.15-3.25,0-4.49L355.3,378.32a8,8,0,0,0-3.89-.93Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.75, -0.43, 0.87, 0.5, 262.42, 459.39)",
    style: {
      fontSize: "29.531850814819336px",
      fill: "#BA68C8",
      fontFamily: "Rubik-Medium, Rubik",
      fontWeight: 500
    }
  }, "GIVE", /*#__PURE__*/React.createElement("tspan", {
    x: 67.33,
    y: 0,
    style: {
      letterSpacing: "-0.03799264527599525em"
    }
  }, "AW"), /*#__PURE__*/React.createElement("tspan", {
    x: 109.56,
    y: 0,
    style: {
      letterSpacing: "-0.07699238202852757em"
    }
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 128.08,
    y: 0,
    style: {
      letterSpacing: "-0.02899564322257175em"
    }
  }, "Y")))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Megaphone--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--megaphone--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.67,328.19a13.16,13.16,0,1,1-13.27-13A13.14,13.14,0,0,1,461.67,328.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.11,329.91l-14.77,8.71a13.16,13.16,0,0,0,19-17.76C460.56,324.2,459.86,327.11,455.11,329.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,337.41l-9.21-5.21a135.3,135.3,0,0,1,4,38.06l3.68,2.09C446.58,365.32,446.93,351,446,337.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.15,337.22l-3.82,5,0,14.4a18.4,18.4,0,0,1-8.88,15.77h0c2.12-8.36,2.24-22.54,1.52-34.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.11,353.74l.27.15a1.72,1.72,0,0,0,1.56,0l2.09-1.23c.43-.25.78-.06.79.44v.31a1.73,1.73,0,0,1-.77,1.36L446.93,356a1.69,1.69,0,0,1-1.56,0l-.25-.15a1.78,1.78,0,0,1-.79-1.36v-.31C444.33,353.7,444.67,353.49,445.11,353.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.82,358.46l.27.15a1.74,1.74,0,0,0,1.57,0l2.08-1.23c.43-.25.79-.06.79.44v.31a1.7,1.7,0,0,1-.77,1.36l-2.12,1.25a1.67,1.67,0,0,1-1.55,0l-.26-.15a1.74,1.74,0,0,1-.78-1.36v-.31C444,358.42,444.39,358.21,444.82,358.46Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.53,363.18l.28.15a1.72,1.72,0,0,0,1.56,0l2.09-1.23c.43-.26.78-.06.78.44v.31a1.73,1.73,0,0,1-.77,1.36l-2.12,1.25a1.69,1.69,0,0,1-1.56,0l-.25-.15a1.75,1.75,0,0,1-.79-1.36v-.31C443.75,363.14,444.1,362.93,444.53,363.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.3,320.55h0c1.75-1,4.12-1,6.76.26.27.13.56.27.84.43s.66.4,1,.62a17.65,17.65,0,0,1,1.58,1.19,21.91,21.91,0,0,1,2.67,2.69,25.9,25.9,0,0,1,4.93,9.18,18.33,18.33,0,0,1,.76,4.87c0,3.34-1.1,5.73-2.95,6.9l6.59-3.87v0a8.56,8.56,0,0,0,3.84-7.42,18.31,18.31,0,0,0-.69-4.65,25.84,25.84,0,0,0-5-9.4,21.07,21.07,0,0,0-2.66-2.68,17.32,17.32,0,0,0-1.58-1.2c-.33-.22-.66-.42-1-.61s-.57-.3-.86-.43a8.48,8.48,0,0,0-7.5.19h0l-.19.1-.23.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.48,342.82v0a8.56,8.56,0,0,0,3.84-7.42,18.31,18.31,0,0,0-.69-4.65l-7.54,4.19a18.33,18.33,0,0,1,.76,4.87c0,3.34-1.1,5.73-2.95,6.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.2,327.56c.07,6.86,5,15.16,10.93,18.54,3,1.7,5.71,1.83,7.65.66l.11-.07c1.85-1.17,3-3.56,2.95-6.9-.06-6.86-4.95-15.16-10.93-18.55-3-1.68-5.67-1.82-7.6-.69S428.17,324.12,428.2,327.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.2,327.56c.07,6.86,5,15.16,10.93,18.54,3,1.7,5.71,1.83,7.65.66l.11-.07c1.85-1.17,3-3.56,2.95-6.9-.06-6.86-4.95-15.16-10.93-18.55-3-1.68-5.67-1.82-7.6-.69S428.17,324.12,428.2,327.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.19,326.08s10.91,5.47,20.33,21.45a73.55,73.55,0,0,1,4.48,8.91c4.76,11.38,4.44,19.25,4.44,19.25,3.16-7.95,7.11-16.19,13.77-22.53a102.19,102.19,0,0,1,8.19-7h0c1.77-1,2.79-3.29,2.76-6.38a18.86,18.86,0,0,0-1.27-6.31,25.15,25.15,0,0,0-1.88-3.92,21.29,21.29,0,0,0-7.43-7.71c-2.69-1.52-5.15-1.72-6.92-.68h0A104.25,104.25,0,0,1,421.58,325C412.81,327.7,403.68,327.16,395.19,326.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.19,326.08s10.91,5.47,20.33,21.45a73.55,73.55,0,0,1,4.48,8.91c4.76,11.38,4.44,19.25,4.44,19.25,3.16-7.95,7.11-16.19,13.77-22.53a102.19,102.19,0,0,1,8.19-7h0c1.77-1,2.79-3.29,2.76-6.38a18.86,18.86,0,0,0-1.27-6.31,25.15,25.15,0,0,0-1.88-3.92,21.29,21.29,0,0,0-7.43-7.71c-2.69-1.52-5.15-1.72-6.92-.68h0A104.25,104.25,0,0,1,421.58,325C412.81,327.7,403.68,327.16,395.19,326.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,356.44c4.76,11.38,4.44,19.25,4.44,19.25,3.16-7.95,7.11-16.19,13.77-22.53a102.19,102.19,0,0,1,8.19-7h0c1.77-1,2.79-3.29,2.76-6.38a18.86,18.86,0,0,0-1.27-6.31C439.69,337.68,426.44,345.39,420,356.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.88,341.75c.07,7.16,2.34,15,6.07,22.17h0c4.79,9.22,12,17.43,19.94,21.94,14.22,8,25.62,1.32,25.47-15a43.17,43.17,0,0,0-1.79-11.56,61,61,0,0,0-15.75-26.16c-1-1-2.05-1.89-3.12-2.75l-1.34-1h0c-.64-.47-1.29-.93-1.94-1.36s-1.37-.86-2.06-1.25C386.14,318.7,374.73,325.42,374.88,341.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,363.93c4.79,9.22,12,17.43,19.94,21.94,14.22,8,25.62,1.32,25.47-15a43.17,43.17,0,0,0-1.79-11.56h0c-.93,2.12-4.35,5.16-5.9,3.07a39.29,39.29,0,0,1,1.57,10.25c0,4.69-1,8.49-2.92,11a8.37,8.37,0,0,1-6.86,3.25A19.55,19.55,0,0,1,401,384c-6.79-3.84-13.07-10.79-17.54-18.69C383.46,365.28,382.58,366,381,363.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.64,342.65c.07,7.21,2.67,15.33,6.82,22.63,4.47,7.9,10.75,14.85,17.54,18.69a19.55,19.55,0,0,0,9.45,2.88,8.37,8.37,0,0,0,6.86-3.25c1.95-2.49,3-6.29,2.92-11a39.29,39.29,0,0,0-1.57-10.25c-.38-1.33-.81-2.66-1.31-4a56.83,56.83,0,0,0-3.08-6.83l-.74-1.36c-.42-.75-.86-1.49-1.31-2.22a57.79,57.79,0,0,0-5.11-7.06l-.07-.07a49.85,49.85,0,0,0-3.86-4.07c-1-.9-1.94-1.75-2.94-2.53-.42-.33-.84-.65-1.27-1s-1-.71-1.55-1.05-1-.64-1.53-.93a19.56,19.56,0,0,0-9.46-2.89C380.22,328.48,376.56,333.8,376.64,342.65Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.64,342.65c.07,7.21,2.67,15.33,6.82,22.63,4.47,7.9,10.75,14.85,17.54,18.69a19.55,19.55,0,0,0,9.45,2.88,8.37,8.37,0,0,0,6.86-3.25c1.95-2.49,3-6.29,2.92-11a39.29,39.29,0,0,0-1.57-10.25c-.38-1.33-.81-2.66-1.31-4a56.83,56.83,0,0,0-3.08-6.83l-.74-1.36c-.42-.75-.86-1.49-1.31-2.22a57.79,57.79,0,0,0-5.11-7.06l-.07-.07a49.85,49.85,0,0,0-3.86-4.07c-1-.9-1.94-1.75-2.94-2.53-.42-.33-.84-.65-1.27-1s-1-.71-1.55-1.05-1-.64-1.53-.93a19.56,19.56,0,0,0-9.46-2.89C380.22,328.48,376.56,333.8,376.64,342.65Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.22,348.7l8.87,15.37c3.65-2,8.09-4.43,13.73-4.36-.15-.44-.3-.87-.47-1.32a57.57,57.57,0,0,0-3.08-6.82c-.24-.46-.49-.92-.74-1.36-.42-.75-.86-1.5-1.31-2.23a57.67,57.67,0,0,0-5.11-7.05l-.07-.08-.82-1C403.46,344.93,395.22,348.7,395.22,348.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.88,364.32c1.9,0,3-1.56,3-4.14v-.08a14,14,0,0,0-6.46-11l-.07,0a5.45,5.45,0,0,0-2.66-.8c-1.91,0-3,1.56-3,4.14v.08a14.1,14.1,0,0,0,6.46,11l.07,0a5.51,5.51,0,0,0,2.67.81Z",
    style: {
      fill: "#BA68C8"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerceI);
export default __webpack_public_path__ + "static/media/ecommerceI.7413885e627dbd14f6ec0d828012279e.svg";
export { ForwardRef as ReactComponent };